import {
  type OfferV11,
  type PrescriptionV3PrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { priceAccessorGetDisplayPrice } from './priceAccessorGetDisplayPrice'

export const priceAccessorGetDisplayPriceInCents = (
  offer: OfferV11,
  prescriptionType: PrescriptionV3PrescriptionTypeEnum,
): number | null => {
  const { price } = priceAccessorGetDisplayPrice(offer, prescriptionType) ?? {}

  if (!price || Number.isNaN(price)) {
    return null
  }

  return Math.round(price * 100)
}
